var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-index"},[_c('div',{staticClass:"index-body flex"},[_c('div',{staticClass:"index-content"},[_c('div',{staticClass:"content"},[_c('page-assets')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }